var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("GST Invoice "),
        _c("span", [
          _vm._v(" " + _vm._s(_vm.innerValue.adjustGstInvoiceNo) + " "),
        ]),
      ]),
    ]),
    _c(
      "table",
      { staticClass: "table is-bordered is-striped is-narrow is-fullwidth" },
      [
        _vm._m(0),
        _c("tfoot", [
          _c("tr", [
            _c("th", { staticClass: "has-text-left" }, [_vm._v("GST")]),
            _c(
              "th",
              { staticClass: "has-text-left", attrs: { colspan: "4" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$filters.formatCurrency(
                      _vm.innerValue.gst,
                      _vm.$userInfo.locale
                    )
                  )
                ),
              ]
            ),
          ]),
        ]),
        _vm.gstPaid || _vm.readOnlyView
          ? _c("tbody", [
              _c("tr", [
                _c("td", [
                  _vm._v(_vm._s(_vm.innerValue.gstItem.glAccountName)),
                ]),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumber(
                          _vm.innerValue.gstItem.unitPrice,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$filters.formatNumber(
                            _vm.innerValue.gstItem.newValue,
                            _vm.$userInfo.locale
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$filters.formatNumber(
                            _vm.innerValue.gstItem.totalExGst,
                            _vm.$userInfo.locale
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("td", [
                  _vm._v(_vm._s(_vm.innerValue.gstItem.invoiceItemDesc)),
                ]),
              ]),
            ])
          : _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "has-vertical-middle" }, [
                  _vm._v(_vm._s(_vm.innerValue.gstItem.glAccountName)),
                ]),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumber(
                          _vm.innerValue.gstItem.unitPrice,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                !_vm.gstPaid
                  ? _c(
                      "td",
                      { staticClass: "has-text-right money-input" },
                      [
                        _c("vue-numeric", {
                          staticClass: "input has-text-right",
                          attrs: { min: 0, precision: 2 },
                          on: {
                            input: function ($event) {
                              return _vm.updateNewValue(_vm.innerValue.gstItem)
                            },
                          },
                          model: {
                            value: _vm.innerValue.gstItem.newValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.innerValue.gstItem,
                                "newValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "innerValue.gstItem.newValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticClass: "has-vertical-middle has-text-right" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatNumber(
                                _vm.innerValue.gstItem.newValue,
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                !_vm.gstPaid
                  ? _c(
                      "td",
                      { staticClass: "has-text-right money-input" },
                      [
                        _c("vue-numeric", {
                          staticClass: "input has-text-right",
                          attrs: { minus: true, precision: 2 },
                          on: {
                            input: function ($event) {
                              return _vm.updateAdjustValue(
                                _vm.innerValue.gstItem
                              )
                            },
                          },
                          model: {
                            value: _vm.innerValue.gstItem.totalExGst,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.innerValue.gstItem,
                                "totalExGst",
                                _vm._n($$v)
                              )
                            },
                            expression: "innerValue.gstItem.totalExGst",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticClass: "has-vertical-middle has-text-right" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatNumber(
                                _vm.innerValue.gstItem.totalExGst,
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                _c("td", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.gstItem.invoiceItemDesc,
                        expression: "innerValue.gstItem.invoiceItemDesc",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text", placeholder: "Remark" },
                    domProps: { value: _vm.innerValue.gstItem.invoiceItemDesc },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.innerValue.gstItem,
                          "invoiceItemDesc",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Account")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Amount")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("New Value")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Adjust Value")]),
        _c("th", [_vm._v("Remark")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }